import { mapActions, mapMutations, mapState } from 'vuex'
import Helper from '../../../../helpers/helpers';

export default {
    computed: {
        ...mapState('user', {
            userProfile: state => state.userProfile,
            currentUser: state => state.currentUser,
        }),
        ...mapState('dashboard', {
            activeTab: state => state.activeTab,
        }),
    },
    methods: {
        ...mapActions('user', {
            copyUserProfileUrl: 'copyUserProfileUrl'
        }),
        ...mapMutations('dashboard', {
            setActiveTab: 'setActiveTab'
        }),
        copyProfileUrlToClipboard() {
            return Helper.copyUserProfileUrl(this.userProfile.profile_link);
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/dashboard/components/dashboard-aside/dashboard-aside.js